import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';
import { useTranslation } from 'react-i18next';
import { deletePromotion } from '../../../actions/promotionActions';
import { toast } from 'react-toastify';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';

export interface DeleteProps {
  done: () => void;
  id?: string;
  cancel: () => void;
}

function Delete({ done, id, cancel }: DeleteProps) {
  const { t } = useTranslation();

  const handleDelete = () => {
    if (!id) return;
    deletePromotion(id)
      .then(() => {
        toast.success(t('Promotion successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete promotion'));
      });
  };

  return (
    <SlideoutLayout title={t('Delete confirmation')} cancel={cancel}>
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-default me-2"
          onClick={handleDelete}
          text={t('Yes, delete the promotion')}
        />
        <Button
          className="btn btn-primary"
          onClick={cancel}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default Delete;
